import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";

// import reducers
import loaderReducer from "./loader";
import alertReducer from "./alerts";
import verticalsReducer from "./verticals/reducer";
import authReducer from "./auth";
import dataReducer from "./logs";

// create reducer object
const rootReducer = combineReducers({
  loader: loaderReducer,
  alerts: alertReducer,
  verticals: verticalsReducer,
  auth: authReducer,
  leads: dataReducer
});

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

// configure store
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
